<script lang="ts">
	import PopBox from './popBox.svelte';

	let { rawTag }: { rawTag: string } = $props();

	let tag = rawTag.split('/');
</script>

<PopBox style="background-color: #ff65a3; padding: 0.2em; width: fit-content">
	{#each tag as subTag, i}
		<a style="color: black" href={`/tag/${tag.slice(0, i + 1).join('/')}`}>{subTag}</a
		>{#if i + 1 != tag.length}
			/
		{/if}
	{/each}
</PopBox>
